export { default, type IItem as CardInfoListItem } from './card-info-list';
